export default "__VITE_ASSET__Bzh4vGy3__"